import usePrivateAxios from "@/common/api/usePrivateAxios";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { MissionsTransformer } from "../services/missionsTransformer";
import { MissionFilters } from "../types/mission.type";

type UseMissionsListProps = {
  filters?: MissionFilters & { establishmentId?: string }
}

export const useMissionsList = ({ filters }: UseMissionsListProps) => {
  const privateAxios = usePrivateAxios()
  const {
    search,
    page,
    status,
    validity,
    establishmentId,
  } = filters || {}

  return useQuery({
    queryKey: [
      'missions',
      search ?? null,
      page ?? null,
      status ?? null,
      validity ?? null,
      establishmentId ?? null,
    ],
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const response = await privateAxios.get('/tmais/missions', {
        params: {
          search: search || undefined,
          page: page || undefined,
          status: status || undefined,
          validity: validity || undefined,
          establishment_id: establishmentId || undefined,
        },
      })
      const payload = response.data?.data || response.data || []
      const included = response.data?.included
      const meta = response.data?.meta || response.data?.pagination || {}
      const missions = MissionsTransformer.listFromApi(payload, included)
      return {
        data: missions,
        rows: MissionsTransformer.toTableRows(missions),
        meta,
      }
    },
  })
}

